import styled from "styled-components";

const CommonMsg = styled.div`
  position: relative;
  padding: 10px 15px;
  border-radius: 5px;
  margin-bottom: 30px;
  padding-right: 20px;
  a.dismiss:link {
    position: absolute;
    top: 4px;
    right: 6px;
    text-decoration: none;
    font-weight: bold;
  }
`;

export const ErrorMsg = styled<any>(CommonMsg)`
  background-color: ${(p) => (p.backgroundColor ? "p.backgroundColor" : "tomato")};
  color: ${(p) => (p.color ? p.color : "white")};
  a.dismiss:link {
    color: ${(p) => (p.color ? p.color : "white")};
  }
`;

export const WarningMsg = styled<any>(CommonMsg)`
  background-color: ${(p) => (p.backgroundColor ? p.backgroundColor : "#ffeacc")};
  color: ${(p) => (p.color ? p.color : "black")};
  a.dismiss:link {
    color: ${(p) => (p.color ? p.color : "black")};
  }
`;

export const NoticeMsg = styled<any>(CommonMsg)`
  background-color: ${(p) => (p.backgroundColor ? p.backgroundColor : "black")};
  color: ${(p) => (p.color ? p.color : "white")};
  a.dismiss:link {
    color: ${(p) => (p.color ? p.color : "white")};
  }
`;
